<template>
  <section class="final-cta">
    <div class="container">
      <div class="cta-content">
        <div class="cta-image-wrapper">
          <img :src="$t('homePage.cta.image')" alt="Wellness" class="cta-image" />
        </div>
        <h2>{{ $t('homePage.cta.title') }}</h2>
        <p>{{ $t('homePage.cta.subtitle') }}</p>
        <div class="cta-buttons">
          <router-link to="/search" class="btn btn-primary btn-lg">{{ $t('homePage.cta.cta_member') }}</router-link>
          <router-link to="/register/professional" class="btn btn-secondary btn-lg">{{
            $t('homePage.cta.cta_professional')
          }}</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FinalCTA'
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.final-cta {
  padding: 5rem 0;
  background: linear-gradient(135deg, $brand-dark 0%, $brand-color 100%);
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -10%;
    width: 500px;
    height: 500px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 50%;
    z-index: 1;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
}

.cta-content {
  position: relative;
  z-index: 2;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
      font-size: 1.8rem;
    }
  }

  p {
    font-size: 1.1rem;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 2.5rem;
  }
}

.cta-image-wrapper {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
}

.cta-image {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid white;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    width: 150px;
    height: 150px;
  }
}

.cta-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;

    .btn {
      width: 100%;
    }
  }
}

/* Buttons */
.btn {
  display: inline-block;
  padding: 12px 32px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;

  &.btn-primary {
    background: white;
    color: $brand-color;

    &:hover {
      background: rgba(255, 255, 255, 0.9);
      transform: translateY(-2px);
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
    }
  }

  &.btn-secondary {
    background: transparent;
    color: white;
    border: 2px solid white;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: translateY(-2px);
    }
  }

  &.btn-lg {
    padding: 16px 48px;
    font-size: 1.1rem;
  }
}
</style>
